export default __webpack_public_path__ + "static/media/14559.london-banking-tour-committee.photo.c95b9d31.jpeg";